import React, { useEffect, useRef, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Label,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import { formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const PartialDeliveryFromCentralKitchenReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [selectedRow, setSelectedRow] = useState([]);
  const [orderDetailsModal, setOrderDetailsModal] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    const firstDay = new Date(
      currentDay.getFullYear(),
      currentDay.getMonth(),
      1,
    );
    setDateFrom(formatDate(firstDay));
    setDateTo(formatDate(currentDay));
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
      setAllOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 30) {
        setFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      const url =
        process.env.REACT_APP_BASEURL +
        "reports/partial_delivery_from_central_kitchen";
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
      });
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        const allData = (response.data || []).map((row, index) => ({
          ...row,
          row_key: row._id || row.order_id || `row_${index}`,
          branch_name:
            row.branch_details && row.branch_details.name
              ? row.branch_details.name
              : "",
        }));
        if (allData.length <= 0) {
          showNotification("No Orders data found", "error");
        }
        setFilteredOrders(allData);
        setAllOrders(allData);
      } else {
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  function afterFilter(newResult, newFilters) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Order"),
      dataField: "order_id",
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedRow(row);
              setOrderDetailsModal(true);
            }}
          >
            {row.order_id}
          </span>
        );
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "branch_name",
      text: props.t("Branch Name"),
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.branch_name)
                .map((row) => [
                  row.branch_name,
                  { value: row.branch_name, label: row.branch_name },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
      style: { cursor: "pointer" },
    },
    {
      dataField: "remarks",
      text: props.t("Branch Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      style: { cursor: "pointer" },
    },
    {
      dataField: "admin_remarks",
      text: props.t("Admin Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      style: { cursor: "pointer" },
    },
    {
      text: props.t("Status"),
      dataField: "status",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.status)
                .map((row) => [
                  row.status,
                  { value: row.status, label: row.status },
                ]),
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        },
      }),
    },
    {
      text: props.t("Date"),
      dataField: "date_to_process",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      formatter: (cell, row, rowIndex) => {
        return moment(row.date_to_process).format("DD/MM/YYYY");
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Completed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Booked") {
      style.backgroundColor = "#9ec3ff";
    } else if (row.status === "In Process") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Cancelled") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  const handleDownload = async () => {
    const fileName = "partial_delivery_from_central_kitchen_report";
    const exportType = "xls";

    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Order: v.order_id,
          Branch_Name: v.branch_name,
          Branch_Remarks: v.remarks,
          Admin_Remarks: v.admin_remarks,
          Status: v.status,
          Date: moment(v.date_to_process).format("DD/MM/YYYY"),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  const columns_ordered_products = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "25%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Order Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Avail. Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available);
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
    },
  ];

  const columns_delivered_products = [
    {
      text: props.t("Section"),
      dataField: "section",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Del. Qty."),
      dataField: "delivered_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivered_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Rec. Qty."),
      dataField: "received_quantity",
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t(
              "Partial Delivery From Central Kitchen Report",
            )}
            title={props.t("Reports")}
            breadcrumbItem={props.t(
              "Partial Delivery From Central Kitchen Report",
            )}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={4}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={4}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Partial Delivery From Central Kitchen Report")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="row_key"
                      data={allOrders && allOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            rowStyle={rowStyle}
                            filter={filterFactory({ afterFilter })}
                            pagination={paginationFactory(pagination_options)}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    isOpen={orderDetailsModal}
                    toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                  >
                    <ModalHeader
                      toggle={() => setOrderDetailsModal(!orderDetailsModal)}
                    >
                      {props.t("Order Details")}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Row>
                          <Col lg={12}>
                            <Card>
                              <CardBody>
                                <Row>
                                  <Col lg={12} md={12}>
                                    <Label>Ordered Products</Label>
                                  </Col>

                                  <Col lg={12}>
                                    <BootstrapTable
                                      bootstrap4
                                      keyField="name"
                                      data={
                                        (selectedRow &&
                                          selectedRow.product_details) ||
                                        []
                                      }
                                      columns={columns_ordered_products}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                    <hr />
                                  </Col>

                                  {selectedRow &&
                                  selectedRow.delivery_details &&
                                  selectedRow.delivery_details.length > 0 ? (
                                    <>
                                      <Col lg={12} md={12}>
                                        <br />
                                        <Label>
                                          <b>
                                            {props.t("Delivered Products")}{" "}
                                          </b>
                                        </Label>
                                      </Col>
                                      <Col lg={12} className="mb-4">
                                        <BootstrapTable
                                          bootstrap4
                                          keyField="name"
                                          key="name"
                                          data={selectedRow.delivery_details}
                                          columns={columns_delivered_products}
                                          noDataIndication="No data to display."
                                          striped
                                          hover
                                          condensed
                                        />
                                        <hr />
                                      </Col>
                                    </>
                                  ) : null}
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        </Row>
                      </>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(
    mapStatetoProps,
    {},
  )(withNamespaces()(PartialDeliveryFromCentralKitchenReport)),
);
